var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_Layer_",
    "data-name": "<Layer>",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.78,12.6a4.36,4.36,0,0,0,0-.51,6.79,6.79,0,0,0,0-.78l2.38-1.76-3-5.18-2.8,1.22A7.5,7.5,0,0,0,15.29,5L15,2H9L8.63,5a7.56,7.56,0,0,0-1.11.63L4.8,4.43l-3,5.18,2.34,1.74c0,.24,0,.49,0,.74s0,.44,0,.66l-2.3,1.7,3,5.18,2.6-1.13a8.27,8.27,0,0,0,1.29.74L9.05,22h6l.33-2.86a7.87,7.87,0,0,0,1.22-.73l2.62,1.14,3-5.18Zm-7,4.3a4.87,4.87,0,1,1,4-4A4.88,4.88,0,0,1,12.73,16.9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.f55861d2634ba3d5f7765e7687e56183.svg";
export { ForwardRef as ReactComponent };